<div class="h-100">
  <div class="container h-100">
    <app-global-status-handling class="z-top d-flex justify-content-center w-100 flex-wrap"></app-global-status-handling>
    <router-outlet></router-outlet>
  </div>
</div>

